export default "__VITE_ASSET__BIBeT7Qc__"